import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchNotificationUnread,
  fetchNotifications,
  markAllNotificationsRead,
  markNotificationRead,
  type NotificationCategory,
} from '@/services/notificationService';

export const notificationKeys = {
  unread: ['notifications', 'unread'] as const,
  list: (category: NotificationCategory) => ['notifications', category] as const,
};

export function useUnreadNotifications(enabled = true) {
  return useQuery({
    queryKey: notificationKeys.unread,
    queryFn: fetchNotificationUnread,
    enabled,
  });
}

export function useNotificationList(category: NotificationCategory) {
  return useQuery({
    queryKey: notificationKeys.list(category),
    queryFn: () => fetchNotifications(category),
  });
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markNotificationRead,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markAllNotificationsRead,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}
